/**
 * @module builder
 */

import type { BulkAction } from '..'
import type { UpdateableAreaSubstrate } from '../../area-substrates'
import { calculateMaterial } from '../../area-substrates/calculate-material'

export function updateSubstrateProduct(
  action: BulkAction,
  substrate: UpdateableAreaSubstrate
): UpdateableAreaSubstrate {
  // Replace oldProduct w/ newProduct on areaSubstrate
  const updatedSubstrate = {
    ...substrate
  }

  const existingProduct = substrate.products.filter((value) => value.key === substrate.key)[0]
  if (action.newProduct.label === 'REMOVE_PRODUCT') {
    // If material removal, handle here
    updatedSubstrate.products = updatedSubstrate.products.filter((value) => value.key !== action.oldProduct)
  } else if (action.oldProduct === 'ADD_NEW_PRODUCT') {
    // If material addition, handle here
    const price = action.newProduct?.price ? action.newProduct.price : 0
    const newMaterial = {
      ...action.newProduct,
      color: action.newProduct?.color ?? '',
      quantity: action.newProduct?.quantity ? action.newProduct?.quantity : 1,
      product: {
        color: action.newProduct?.color ?? '',
        label: action.newProduct.label,
        name: action.newProduct.key,
        unitLabel: action.newProduct?.unitLabel ?? ''
      },
      coverage: { default: action.newProduct.coverage, useCustom: false, custom: 0 },
      lnftCoverage: { default: action.newProduct.lnftCoverage, useCustom: false, custom: 0 },
      quantityCoverage: { default: action.newProduct.quantityCoverage, useCustom: false, custom: 0 },
      volume: { default: 0, useCustom: false, custom: 0 },
      price: { default: price, useCustom: false, custom: 0 },
      totalPrice: { default: 0, useCustom: false, custom: 0 }
    }
    const calculatedMaterial = calculateMaterial(newMaterial)

    updatedSubstrate.products = updatedSubstrate.products.map((value) => {
      if (value.key === action.oldProduct) {
        console.log('replacing')
        return calculatedMaterial
      }
      return value
    })
  } else {
    // If material swap, handle here
    const price = action.newProduct?.price ? action.newProduct.price : 0
    const newMaterial = {
      ...action.newProduct,
      color: action.newProduct?.color ?? existingProduct?.color ?? '',
      quantity: existingProduct?.quantity
        ? existingProduct.quantity
        : action.newProduct?.quantity
          ? action.newProduct?.quantity
          : 1,
      product: {
        color: action.newProduct?.color ?? existingProduct?.color ?? '',
        label: action.newProduct.label,
        name: action.newProduct.key,
        unitLabel: action.newProduct?.unitLabel ?? ''
      },
      coverage: { default: action.newProduct.coverage, useCustom: false, custom: 0 },
      lnftCoverage: { default: action.newProduct.lnftCoverage, useCustom: false, custom: 0 },
      quantityCoverage: { default: action.newProduct.quantityCoverage, useCustom: false, custom: 0 },
      volume: { default: 0, useCustom: false, custom: 0 },
      price: { default: price, useCustom: false, custom: 0 },
      totalPrice: { default: 0, useCustom: false, custom: 0 }
    }
    const calculatedMaterial = calculateMaterial(newMaterial)

    updatedSubstrate.products = updatedSubstrate.products.map((value) => {
      if (value.key === action.oldProduct) {
        return calculatedMaterial
      }
      return value
    })
  }

  return updatedSubstrate
}
